module.exports = __webpack_public_path__ + "img/getoff_btn.b10ac570.png";